import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../styles/colors';
import DialogModal from '../DialogModal';
import Button from '../Button';

const RoundedModal = styled(DialogModal)`
  .MuiDialogContent-root, .MuiPaper-root {
    border-radius: 8px;
  }
`;

const ModalContentWrapper = styled.div`
  outline: 0;
  height: fit-content;
  background-color: ${colors.shades.secondary10};
  border-radius: 8px;
  border: 1px solid ${colors.shades.secondary7};
  position:${(props) => props.position || 'relative'};
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 16px;
  margin-top: 20px;
  padding: 28px 50px 40px 50px;
  border-top: 1px solid ${colors.shades.secondary7};
  position: sticky;
  bottom: 0;
  background-color: ${colors.shades.secondary10};
  z-index: 2;
`;

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 66px 50px 14px 50px;
  color: ${colors.shades.secondary3};
  border-bottom: 1px solid ${colors.shades.secondary7};
`;

const Title = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
`;

const Description = styled(Typography)`
  font-size: 14px;
  line-height: 16px;
  font-weight: 400;
  color: ${colors.shades.gamma2};
  margin-top: 5px;
`;

const ModalBody = styled.div`
  position: relative;
  padding: 44px 50px;
  overflow: auto;
`;

// Full-width primary action for the sticky footer (`actionButtons`) of
// DialogRoundedModal-based modals — shared so each migrated modal doesn't redefine it.
// The disabled palette lives in a `&:disabled` block so it ties (and, by source order,
// beats) the base Button's `&:disabled` rule — a plain `background:` here would lose to
// that higher-specificity selector.
const ModalActionButton = styled(Button)`
  border-radius: 5px;
  background: ${colors.shades.beta2};
  color: ${colors.base.alpha};
  cursor: pointer;
  text-transform: none;
  height: fit-content;
  font-size: 14px;
  line-height: 16px;
  width: 100%;
  margin-top: 0;

  &:disabled {
    background: ${colors.shades.gamma1};
    color: ${colors.shades.gamma2};
    cursor: not-allowed;
  }
`;

export {
  Title,
  Description,
  ActionsContainer,
  RoundedModal,
  ModalContentWrapper,
  HeaderContainer,
  ModalBody,
  ModalActionButton,
};
